import React, { PropTypes } from 'react'

export const ApplicationListItemEntryHeader = (props) => {
  return(
    <h4 styleName="app-card__label label label--large">
      <svg role="img" styleName="app-card__icon"><use xlinkHref={props.icon} /></svg>
      {props.title}
    </h4>
  )
}

export const ApplicationListItemEntry = (props) => {
  const {
    title,
    value,
    components: {
      Default = () => null,
      Header  = () => null
    },
    getTemplate,
    t
  } = props
  let formattedValue;
  if(getTemplate){
    formattedValue = t(getTemplate(value))
  }else{
    formattedValue = value
  }
  return(
    <div styleName="app-card__group-split">
      <Header />
      <div styleName="app-card__info">
        {formattedValue}
        <Default />
      </div>
    </div>
  )
}

export const ApplicationListItemEntryNextStep = (props) => {
  const {
    title,
    value,
    components: {
      Default = () => null,
      Header  = () => null
    },
    getTemplate,
    t
  } = props
  if(!value) return null
  return(
    <div styleName="app-card__group-split">
      <Header />
      <div styleName="app-card__info">
        <div styleName="app-card__info app-card__info--review"> No action required</div>
        <Default />
      </div>
    </div>
  )
}

export const ApplicationListItemID = (props) => {
  return (
    <small>
      <em styleName="app-card__info-status">App. ID: {props.id}</em>
    </small>
  )
}

export const ApplicationListItemEntryAmount = (props) => {
  const {
    title,
    value,
    components: {
      Default = () => null,
      Header  = () => null
    },
    getTemplate,
    t
  } = props
  if(!value) return null
  return(
    <div styleName="app-card__group-split">
      <Header />
      <div styleName="app-card__info">
        {value}
        <Default />
      </div>
    </div>
  )
}
